export default __webpack_public_path__ + "static/media/Breastplate of the Revelations of Tarim.d1b60db0.jpg";